import ColaboradorService from '../_services/ColaboradorService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import { colaboradorModel } from '@/models/colaborador'

const state = {
  loading: false,
  loadingStore: false,
  colaboradores: [],
  dropdownColaborador: [],
  currentPage: null,
  urlFirstPage: null,
  urlNextPage: null,
  urlPrevPage: null,
  urlLastPage: null,
  urlPath: null,
  colaboradorSelecionado: undefined,
  erros: '',
  filter: null,

}

const getters = {
  GET_COLABORADORES : (state) => state.colaboradores,
  GET_URL_PATH : (state) => state.urlPath,
  GET_ERROS: state => state.erros,
  GET_DROPDOWN: state => state.dropdownColaborador,

}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  COLABORADOR_SELECIONADO : (state, { colaborador }) => {
    state.colaboradorSelecionado = Object.assign({}, colaborador)
  },

  SET_COLABORADORES : (state, { colaboradores }) => {
    state.colaboradores = JSON.parse(JSON.stringify(colaboradores))
    state.urlFirstPage = colaboradores.first_page_url
    state.urlPrevPage = colaboradores.prev_page_url
    state.urlPrevPage = colaboradores.prev_page_url
    state.urlLastPage = colaboradores.last_page_url
    state.urlPath = colaboradores.path
    state.currentPage = colaboradores.current_page
  },

  SET_DROPDOWN : (state, colaboradores) => {
    state.dropdownColaborador = colaboradores
  },

  MERGE_PESSOA: (state, { pessoa }) => {
    var objOld = Object.assign({}, state.colaboradorSelecionado)
    objOld.pessoa = pessoa
    state.colaboradorSelecionado = Object.assign({}, objOld)
  },

  SET_FILTER: (state, filter) => {
    state.filter = filter
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.colaboradorSelecionado = undefined,

}

const actions = {

  LOAD_DROPDOWN : async ({commit}) => {
    commit('SET_DROPDOWN', [])
    commit('ERASE_ERROS')
    await ColaboradorService.getDropDown()
    .then(response => {
      if (response.data.status) {
        var drop = [{value: '', text: ''}]
        var obj = response.data.colaboradores
        Object.keys(obj).forEach(function (item) {
          var array = { value: obj[item].id, text: obj[item].nm_pessoa }
          drop.push(array)
        })
        commit('SET_DROPDOWN', drop)

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })
  },

  GET_COLABORADORES : async ({ commit, state }) => {
    commit('SET_COLABORADORES', { colaboradores : []})
    commit('ERASE_ERROS')
    await ColaboradorService.getColaboradores(state.filter)
    .then(response => {
      if (response.data.status) {
        commit('SET_COLABORADORES', { colaboradores : response.data.colaboradores })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })
  },

  PAGINATE_COLABORADORES : async ({ commit }, url) => {
    commit('ERASE_ERROS')
    await ColaboradorService.getPagination(url)
    .then(response => {
      if (response.data.status) {
        commit('SET_COLABORADORES', { colaboradores : response.data.colaboradores })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })
  },

  GET_COLABORADOR : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await ColaboradorService.getColaborador(id)
    .then(response => {
      if (response.data.status) {
        commit('COLABORADOR_SELECIONADO', { colaborador : response.data.colaborador })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })

  },

  GET_CPFCNPJ : async ({commit}, cpfcnpj) => {
    commit('ERASE_ERROS')
    if (!cpfcnpj) return
    await ColaboradorService.getCpfCnpj(cpfcnpj)
    .then(response => {
      if (response.data.status) {
        var data = response.data
        if (data.colaborador) {
          commit('COLABORADOR_SELECIONADO', { colaborador : response.data.colaborador })
        } else if (data.pessoa) {
          commit('MERGE_PESSOA', { pessoa: data.pessoa })
        }
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })

  },

  STORE_COLABORADOR : async ({ commit, dispatch }, colaborador) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!colaborador.id || !(colaborador.id > 0)) { 
        var response = await ColaboradorService.postColaborador(colaborador)
      } else {
        var response = await ColaboradorService.putColaborador(colaborador.id, colaborador)
      }

      if (response.data.status) {
        commit('COLABORADOR_SELECIONADO', { colaborador : response.data.colaborador })

        if (state.urlPrevPage || state.urlNextPage) {
          await dispatch('PAGINATE_COLABORADORES', `${state.urlPath}?page=${state.currentPage}`)
        } else {
          await dispatch('GET_COLABORADORES')
        }

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_COLABORADOR : async ({ commit, dispatch }, colaborador) => {
    console.log(colaborador)
    commit('ERASE_ERROS')
    try {
      var response = await ColaboradorService.deleteColaborador(colaborador.id)

      if (response.data.status) {
        await dispatch('GET_COLABORADORES')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  COLABORADOR_SELECIONADO : async ({dispatch, commit}, id) => {
    if (id > 0) { 
      await dispatch('GET_COLABORADOR', id)
    } else {
      var obj = new colaboradorModel.colaborador()
      await commit('COLABORADOR_SELECIONADO', { colaborador: obj })
    }
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/Colaborador/_store/index.js